export * from "./PromotionalRibbon";
